import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  listContainer: {
    maxWidth: 700,
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing(6, 0),
  },
  fileListContainer: {
    padding: theme.spacing(4, 0),
  },
  commentBox: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
  },
  textArea: {
    height: "auto!important",
  },
  commentButton: {
    alignSelf: "flex-end",
    background: theme.palette.Primary.background,
    "&:hover": {
      backgroundColor: theme.palette.Primary.background,
      color: theme.palette.Primary.light,
    },
  },
  uploadButton: {
    backgroundColor: theme.palette.Primary.background,
    textTransform: "capitalize",
    fontWeight: 400,
    "&:hover": {
      backgroundColor: theme.palette.Primary.hoverButton,
      color: theme.palette.Primary.light,
    },
  },
}));

export default useStyles;
